import { Component } from '@angular/core';
import { DisplayableItemsComponent } from '../../../../../shared/components/displayable-content/displayable-items/displayable-items.component';
import { DigitalProductTemplatesViewModel } from './digital-product-templates-view-model';

@Component({
  selector: 'app-digital-product-templates',
  templateUrl: './digital-product-templates.component.html',
  styleUrls: ['./digital-product-templates.component.scss'],
  providers: [DigitalProductTemplatesViewModel],
  standalone: false
})
export class DigitalProductTemplatesComponent extends DisplayableItemsComponent {
  constructor(public override viewModel: DigitalProductTemplatesViewModel) {
    super(viewModel);
  }
}
